module.exports = __webpack_public_path__ + "static/customize_1-6d8eb0e529e20b836b3332e493dc7c61.png";